const STORAGE_KEY = 'spectrum_theme';

export const THEME_DEFAULTS = {
  '--bg-primary': '#0f1419', //0f1419
  '--purple': '#6439c9', //8b5cf6
  '--blue': '#06b6d4',
};

function hexToRgb(hex) {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return { r, g, b };
}

function lighten(hex, amount) {
  const { r, g, b } = hexToRgb(hex);
  const clamp = (v) => Math.max(0, Math.min(255, Math.round(v + amount)));
  return `#${[clamp(r), clamp(g), clamp(b)].map(v => v.toString(16).padStart(2, '0')).join('')}`;
}

function darken(hex, amount) {
  const { r, g, b } = hexToRgb(hex);

  const factor = 1 - amount / 100;

  const clamp = (v) =>
    Math.max(0, Math.min(255, Math.round(v * factor)));

  return `#${[clamp(r), clamp(g), clamp(b)]
    .map((v) => v.toString(16).padStart(2, "0"))
    .join("")}`;
}

function hexToRgbString(hex) {
  const { r, g, b } = hexToRgb(hex);
  return `${r}, ${g}, ${b}`;
}

function applyVars(vars) {
  const root = document.documentElement;

  if (vars['--bg-primary']) {
    const bg = vars['--bg-primary'];
    root.style.setProperty('--bg-primary', bg);
    root.style.setProperty('--bg-secondary', lighten(bg, 12));
    root.style.setProperty('--bg-card', lighten(bg, 22));
    root.style.setProperty('--bg-hover', lighten(bg, 36));
  }

  if (vars['--purple']) {
    const p = vars['--purple'];
    root.style.setProperty('--purple', p);
    root.style.setProperty('--purple-light', lighten(p, 28));
    root.style.setProperty('--purple-dark', darken(p, 20));
    root.style.setProperty('--purple-dark-2', darken(p, 70));
    root.style.setProperty('--purple-darker', darken(p, 50));
  }

  if (vars['--blue']) {
    root.style.setProperty('--blue', vars['--blue']);
    root.style.setProperty('--blue-light', lighten(vars['--blue'], 28));
  }
}

export function loadSavedTheme() {
  try {
    const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    const merged = { ...THEME_DEFAULTS, ...saved };
    applyVars(merged);
  } catch {
    applyVars(THEME_DEFAULTS);
  }
}

export function getSavedTheme() {
  try {
    const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    return { ...THEME_DEFAULTS, ...saved };
  } catch {
    return { ...THEME_DEFAULTS };
  }
}

export function setThemeColor(variable, value) {
  applyVars({ [variable]: value });
  try {
    const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...saved, [variable]: value }));
  } catch {}
}

export function resetTheme() {
  localStorage.removeItem(STORAGE_KEY);
  applyVars(THEME_DEFAULTS);
}
